import rxios from '../common/rxios'
import { map, tap } from 'rxjs/operators'
import { CreditHistoryDetail, BillingKey } from '../model/billing-model'
import { map as _map } from 'lodash-es'

const BILLING_API_PREFIX = '/billing-api/billing/v4.0'
const BILLING_API_PREFIX_V5 = '/billing-api/billing/v5.0'

export const billingService = {
  getCreditExists$() {
    return rxios.get(`${BILLING_API_PREFIX}/credits/exist`).pipe(map(response => response.data))
  },
  accumulateCredit$() {
    return rxios.post(`${BILLING_API_PREFIX}/credits`).pipe(map(response => response.data))
  },
  getSignupCampaignInfo$(){
    return rxios.get(`${BILLING_API_PREFIX}/signup-campaign`).pipe(map(response => response.data))
  },
  /**
   * 자동결제수단 등록 팝업URL 획득 API
   * serviceUrl: 결제수단팝업 처리가 완료된 이후 콜백형태로 호출하는 URL (서버 to 서버) 로컬테스트를 위해서는 도메인주소를 변경해야함. GET방식
   * returnUrl: serviceUrl의 처리가 완료된 이후 팝업을 리다이렉트 하기위해 호출하는 URL. POST방식
   */
  getAutoPaymentPopupUrl$() {
    return rxios
      .get(`${BILLING_API_PREFIX}/billing-keys/auto-payment/popup`, {
        params: {
          serviceUrl: `${location.origin}/homepage/v1/billing/keys/auto-payment`,
          returnUrl: `${location.origin}/homepage/v1/billing/keys/auto-payment`
        }
      })
      .pipe(map(response => response.data.url))
  },
  getRefundPopupUrl$(paymentGroupId, month) {
    return rxios
      .get(`${BILLING_API_PREFIX}/payments/${month}/refund-account-register-popup`, {
        params: {
          paymentGroupId: paymentGroupId,
          returnUrl: `${location.origin}/account/payment/popup-close`
        }
      })
      .pipe(map(response => response.data.refundPopUpUrl))
  },
  getReceivers$() {
    return rxios.get(`${BILLING_API_PREFIX}/specifications`).pipe(map(response => response.data.receivers))
  },
  registerReceiver$(emailAddress) {
    return rxios
      .post(`${BILLING_API_PREFIX}/specifications`, {
        emailAddress
      })
      .pipe(map(response => response.data))
  },
  deleteReceiver$(seq) {
    return rxios
      .delete(`${BILLING_API_PREFIX}/specifications`, {
        params: {
          seq
        }
      })
      .pipe(map(response => response.data))
  },
  getPaymentViewers$(memberUuid) {
    return rxios.get(`/homepage/v1/billing/member/payment-viewer`).pipe(map(response => response.data.paymentViewers))
  },
  registerPaymentViewers$(memberUuid, paymentViewerEmail, description, monthFrom, monthTo) {
    return rxios
      .post(`/homepage/v1/billing/member/payment-viewer`, {
        description,
        monthFrom,
        monthTo,
        paymentViewerEmail
      })
      .pipe(map(response => response.data))
  },
  deletePaymentViewer$( memberUuid ,paymentViewerUuid) {
    return rxios
      .delete(`/homepage/v1/billing/member/payment-viewer/${paymentViewerUuid}`)
      .pipe(map(response => response.data))
  },

  getBillingKey$() {
    return rxios.get(`${BILLING_API_PREFIX}/billing-keys`).pipe(map(response => new BillingKey(response.data.billingKey)))
  },
  modifyBillingKey$(unified) {
    return rxios
      .put(`${BILLING_API_PREFIX}/billing-keys`, {
        unified
      })
      .pipe(map(response => response.data))
  },
  getCampaignName$() {
    return rxios
      .get(`${BILLING_API_PREFIX}/signup-campaign`, {
        params: {}
      })
      .pipe(
        map(response => {
          return response.data.campaignName
        })
      )
  },
  getCreditHistory$(page, itemsPerPage, balancePriceTypeCode) {
    return rxios
      .get(`${BILLING_API_PREFIX}/credits/history`, {
        params: {
          balancePriceTypeCode,
          page,
          itemsPerPage
        }
      })
      .pipe(
        map(response => {
          response.data.creditHistories = _map(response.data.creditHistories, credit => {
            credit.showAll = false
            return credit
          })
          return response.data
        })
      )
  },
  getBalanceType$(balanceTypeCode) {
    return rxios
      .get(`${BILLING_API_PREFIX}/admin/codes`, {
        params: {
          codeType: 'BALANCE_TYPE',
          codeId: balanceTypeCode
        }
      })
      .pipe(
        map(response => {
          return response.data
        })
      )
  },
  registerCoupon$(couponCode) {
    return rxios.post(`${BILLING_API_PREFIX}/coupons/${couponCode}`).pipe(map(response => response.data))
  },
  getPaymentsStatements$(lang, page, itemPerPage) {
    return rxios
      .get(`/homepage/v1/billing/payments/statements`, {
        params: {
          lang,
          page,
          itemPerPage
        }
      })
      .pipe(map(response => response.data))
  }
}
